import { ErrorPageLayout } from '../../layout/ErrorPageLayout.js';
import { MainLayout } from '../../layout/MainLayout.js';

export const NotSupportedElement = () => {
  return (
    <MainLayout title="Appraiser Toolkit" showNav={false}>
      <ErrorPageLayout
        title={'We are sorry. This report type is not supported.'}
        body={'Toolkit currently supports the following forms: Single Family (1004)'}
      />
    </MainLayout>
  );
};
